import React from 'react'
import ReactApexChart from 'react-apexcharts';
import useWindowDimensions from '../../../utils/useWindowDimensions';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const GameEngagement = ({ modules, counts, loading }) => {
    var { width } = useWindowDimensions();
    const chartOptions = {
        chart: {
            type: 'donut',
        },
        legend: {
            show: false,
            position: 'bottom',
            offsetY: -30
        },
        plotOptions: {
            pie: {
                startAngle: -90,
                endAngle: 90,
                offsetY: 10,
                hollow: {
                    margin: 0,
                    size: '100%',
                    background: 'transparent',
                    image: undefined,
                },
                dataLabels: {
                    enabled: false,
                    name: {
                        show: true,
                    },
                    value: {
                        show: false,
                    },
                },
            },
        },
        stroke: {
            width: 0,
        },
        colors: ['#3e4095', '#CA353B99', '#333333'],
        labels: ['Yet To Start', 'Ongoing', 'Completed'],
        title: {
            align: 'center',
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        show: false,
                        position: 'bottom'
                    },
                },
            },
        ],
    };
    const chartData = [modules.filter((e) => e.progress === 0).length, modules.filter((e) => e.progress > 0 && e.progress < 100).length, modules.filter((e) => e.progress === 100).length];
    return (
        <>
            <h5> {loading ?  <Skeleton width="5vw" />  : <> Module Engagement </> } </h5>
            <div id="chart" className=' gameengajmentchart position-relative ' >
                <ReactApexChart
                    options={chartOptions}
                    series={chartData}
                    type="donut"
                    width="100%"
                    height={width > 1500 ? 300 : 257}
                />
                <div className='tuser'>
                    <h3 className='mb-0'> {loading ?  <Skeleton width="5vw" />  : <> {modules.length} </> }</h3>
                    <p>{loading ?  <Skeleton width="5vw" />  : <>Courses</> }</p>
                </div>
                <div className='legendgamec'>
                    <div className='d-flex justify-content-center gap-2'>
                    {loading ?  <Skeleton width="5vw" />  :  <p><span></span>To Start</p> }
                    {loading ?  <Skeleton width="5vw" />  :     <p><span></span> Ongoing</p>}
                     {loading ?  <Skeleton width="5vw" />  :     <p><span></span> Completed</p>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default GameEngagement
